import { CourierType } from 'components/agencyView/AgencyView';
import { useAgencyCouriersQuery } from 'core/graphql/Agency/AgencyCouriers.generated';
import { Courier, CourierFiltering } from 'core/graphql/types';

type AgencyCouriersResult = {
  couriers: Courier[];
  loadingCouriers: boolean;
  refresh: () => Promise<void>;
};

const useAgencyCouriersDataStore = (
  date: string | null,
  agencyId: string | null,
  courierType: CourierType,
): AgencyCouriersResult => {
  const getFilteringTYpe = (type: CourierType) => {
    switch (+type) {
      case CourierType.CourierWithItineraries: {
        return CourierFiltering.CourierWithItineraries;
      }
      case CourierType.CourierWithoutItineraries: {
        return CourierFiltering.CourierWithoutItineraries;
      }
      default: {
        return CourierFiltering.AllCouriers;
      }
    }
  };

  const { loading, data, refetch } = useAgencyCouriersQuery({
    skip: !agencyId || !date,
    variables:
      agencyId && date && courierType
        ? {
            agencyId,
            date,
            courierFiltering: getFilteringTYpe(courierType),
          }
        : undefined,
  });

  const refresh = async () => {
    await refetch(
      agencyId && date && courierType
        ? {
            agencyId,
            date,
            courierFiltering: getFilteringTYpe(courierType),
          }
        : undefined,
    );
  };

  if (data !== undefined) {
    return {
      couriers: data.CouriersByAgency,
      loadingCouriers: loading,
      refresh,
    };
  }

  return {
    couriers: [],
    loadingCouriers: loading,
    refresh,
  };
};

export default useAgencyCouriersDataStore;
